export default "__VITE_ASSET__YjarC0aw__"